export default __webpack_public_path__ + "static/media/Partnership-White.c8d08839.png";